import { observer } from "mobx-react-lite";

import { useStores } from "../stores/useStores";
import { ThemeStyle } from "./ThemeStyle";

/** The theme chosen in the appearance settings, on the page. It changes as soon as the settings or the system do. */
export const CurrentTheme = observer(function CurrentTheme() {
    const { theme } = useStores();

    return <ThemeStyle colors={theme.colors} dark={theme.base !== "light"} />;
});
